import "./ReoCheckbox.css.ts.vanilla.mjs";
var e = "p273__ReoCheckbox-9738_b52cb4a__y4sulxf", b = { large: "p273__ReoCheckbox-9738_b52cb4a__y4sulxa", medium: "p273__ReoCheckbox-9738_b52cb4a__y4sulxa", small: "p273__ReoCheckbox-9738_b52cb4a__small__y4sulxd p273__ReoCheckbox-9738_b52cb4a__y4sulxa" }, o = "p273__ReoCheckbox-9738_b52cb4a__y4sulx0", c = "p273__ReoCheckbox-9738_b52cb4a__y4sulx7", x = "p273__ReoCheckbox-9738_b52cb4a__y4sulx6", a = "p273__ReoCheckbox-9738_b52cb4a__y4sulx9", r = "p273__ReoCheckbox-9738_b52cb4a__y4sulx8", h = "p273__ReoCheckbox-9738_b52cb4a__y4sulxe", k = "p273__ReoCheckbox-9738_b52cb4a__y4sulx4", l = "p273__ReoCheckbox-9738_b52cb4a__y4sulx5", p = { large: "p273__ReoCheckbox-9738_b52cb4a__y4sulx1", medium: "p273__ReoCheckbox-9738_b52cb4a__y4sulx2", small: "p273__ReoCheckbox-9738_b52cb4a__y4sulx3" };
export {
  e as checkboxGroup,
  b as checkedIcon,
  o as ghost,
  c as reoCheckbox,
  x as reoCheckboxChecked,
  a as reoCheckboxInner,
  r as reoCheckboxInput,
  h as reoCheckboxLabel,
  k as reoCheckboxWrapper,
  l as reoCheckboxWrapperDisabled,
  p as sizeMap
};
//# sourceMappingURL=ReoCheckbox.mjs.map
